import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5154';

// Get or create persistent anonymous session ID to isolate rate limits across shared studio Wi-Fi
const getSessionId = () => {
  try {
    let sid = localStorage.getItem('divyayoga_chat_session_id');
    if (!sid) {
      sid = 'sid_' + Math.random().toString(36).substring(2, 15) + '_' + Date.now().toString(36);
      localStorage.setItem('divyayoga_chat_session_id', sid);
    }
    return sid;
  } catch (e) {
    return 'sid_fallback';
  }
};

// Deliberately a bare axios call (not the shared `api` instance) — Ask Divy is a
// public endpoint, no auth token needed, and we don't want the global 401 redirect
// interceptor firing if a visitor isn't logged in.
const chatClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

chatClient.interceptors.request.use((config) => {
  config.headers['x-session-id'] = getSessionId();
  return config;
});

chatClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 429) {
      return Promise.resolve({
        data: {
          reply: "🧘 You're asking questions a bit too fast! Please take a deep breath and try again in a few seconds."
        }
      });
    }
    return Promise.reject(error);
  }
);

export const chatAPI = {
  // history: [{ role: 'user' | 'assistant', content: string }, ...]
  ask: (message, history = []) =>
    chatClient.post('/chat/ask', { message, history }),
};

export default chatAPI;
